import { opFor, type LevelId } from '../../data/ids';
import { t, type StringKey } from '../../i18n/es';
import type { SaveFile, SlotId } from '../../save/schema';
import { formatDate, formatNumber } from '../format';

/** What a slot card of EXPEDIENTES shows (GDD §13.2, §6.3). Pure: the DOM is built from it. */
export type SlotCard =
  | { slotId: SlotId; empty: true }
  | { slotId: SlotId; empty: false; mission: string; lives: string; points: string; date: string };

/** "OP-101 · COMUNA DESPEGUE". */
export function missionLabel(levelId: LevelId): string {
  const name = t(`mission.${levelId}.name` as StringKey);
  return `${opFor(levelId)} · ${name.toLocaleUpperCase('es-ES')}`;
}

export function slotCard(save: SaveFile, slotId: SlotId): SlotCard {
  const slot = save.slots[slotId];
  if (!slot) return { slotId, empty: true };
  return {
    slotId,
    empty: false,
    mission: missionLabel(slot.current.levelId),
    lives: t('ui.expedientes.lives', { n: slot.current.lives }),
    points: t('ui.expedientes.points', { n: formatNumber(slot.current.score) }),
    date: formatDate(slot.updatedAt),
  };
}
